import styles from './contact-form.module.scss';
import texts from './contact-form.texts.json';
import { TextField } from '../../../components/text-field/text-field';
import { TextArea } from '../../../components/text-area/text-area';
import { ButtonWithLoader } from '@y2/mango/components/button/extended-buttons/with-loader';
import type { ContactDetails, WithLeadSource } from '@y2/api-clients/yad1';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { validationSchema } from './validation';
import { pushContactUsFormSubmitEvent } from '../../analytics/contact-events';

type ContactFormProps = {
  onSubmit: (formData: WithLeadSource<ContactDetails>) => void;
  isLoading: boolean;
};

export const ContactForm = ({
  onSubmit: submitContactDetails,
  isLoading,
}: ContactFormProps) => {
  const { control, handleSubmit, formState } = useForm<ContactDetails>({
    resolver: yupResolver(validationSchema),
    mode: 'onChange',
  });

  const onSubmit = (formData: ContactDetails) => {
    submitContactDetails({ ...formData, leadSource: 'Yad1' });
    pushContactUsFormSubmitEvent();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className={styles.contactUsFormFields}>
        <TextField
          name="fullName"
          control={control}
          error={formState.errors.fullName?.message}
          label={texts.labels.fullName}
          placeholder={texts.placeholders.fullName}
          className={styles.field}
        />
        <TextField
          name="projectName"
          control={control}
          error={formState.errors.projectName?.message}
          label={texts.labels.projectName}
          placeholder={texts.placeholders.projectName}
          className={styles.field}
        />
        <TextField
          name="companyName"
          control={control}
          error={formState.errors.companyName?.message}
          label={texts.labels.companyName}
          placeholder={texts.placeholders.companyName}
          className={styles.field}
        />
        <TextField
          name="city"
          control={control}
          error={formState.errors.city?.message}
          label={texts.labels.city}
          placeholder={texts.placeholders.city}
          className={styles.field}
        />
        <TextField
          name="email"
          control={control}
          error={formState.errors.email?.message}
          label={texts.labels.email}
          placeholder={texts.placeholders.email}
          className={styles.field}
        />
        <TextField
          name="phone"
          control={control}
          error={formState.errors.phone?.message}
          label={texts.labels.phone}
          placeholder={texts.placeholders.phone}
          className={styles.field}
        />
        <TextArea
          name="description"
          control={control}
          error={formState.errors.description?.message}
          label={texts.labels.description}
          placeholder={texts.placeholders.description}
          className={styles.textAreaField}
        />
      </div>
      <div className={styles.submitButtonBox}>
        <ButtonWithLoader
          className={styles.submitButton}
          type="submit"
          variant="blue"
          side="left"
          loading={isLoading}
          disabled={!formState.isValid}
        >
          {texts.send}
        </ButtonWithLoader>
      </div>
    </form>
  );
};
